import { CognitoUserSession } from 'amazon-cognito-identity-js';
import { configureWebSocket, configureHttp } from '@/util';
declare global {
  interface Window {
    savedHandler: string;
    savedSessionHost: string;
  }
}

const setHttpAuth = (userSession: CognitoUserSession, handler?: string, host?: string) => {
  console.log('setHttpAuth called with userSession:', userSession);
  console.log('setHttpAuth called with handler:', handler);
  console.log('setHttpAuth called with host:', host);
  // Save handler to window object if provided
  if (handler) {
    window.savedHandler = handler;
  }

  if (host) {
    window.savedSessionHost = host;
  }

  let jwt = '';
  let identityToken = '';

  // Use saved handler if none provided
  const currentHandler = handler || window.savedHandler;
  const currentHost = host || window.savedSessionHost;
  const path = `/${currentHandler}`;

  if (!userSession) {
    return;
  }

  //@ts-expect-error
  if (userSession.accessToken) {
    //@ts-expect-error
    jwt = userSession.accessToken.jwtToken;
    //@ts-expect-error
    identityToken = userSession.idToken
  }


  if (userSession.getAccessToken) {
    jwt = userSession.getAccessToken().getJwtToken();
    identityToken = userSession.getIdToken().getJwtToken();
  }

  configureHttp({
    jwt,
    path,
    identityToken,
  });
  configureWebSocket(jwt, currentHandler, currentHost);

};

export default setHttpAuth;
